export enum UserType {
  Employee = "employee",
  Admin = "admin",
  Wallet = "wallet"
}
